function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.2509761mm",
    height: "7.7119141mm",
    viewBox: "0 0 5.2509761 7.7119141",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.151534,-58.150955)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 48.353679,62.639236 q -0.01953,0.136719 -0.0293,0.278321 -0.0098,0.136719 -0.0098,0.292969 0,0.795898 0.366211,1.225585 0.371093,0.424805 1.049804,0.424805 0.712891,0 1.12793,-0.429687 0.415039,-0.429688 0.415039,-1.171875 0,-0.644532 -0.351562,-0.986328 -0.351563,-0.341797 -1.010743,-0.341797 -0.483398,0 -0.864257,0.175781 -0.375977,0.170898 -0.69336,0.532226 z m 0.0293,-0.698242 q 0.336914,-0.361328 0.771484,-0.537109 0.439454,-0.180664 0.976563,-0.180664 0.9375,0 1.479492,0.541992 0.541992,0.537109 0.541992,1.474609 0,1.040039 -0.693359,1.708985 -0.688477,0.664062 -1.767578,0.664062 -1.098633,0 -1.694336,-0.673828 -0.595703,-0.678711 -0.595703,-1.928711 0,-1.240234 0.512695,-2.299804 0.512695,-1.059571 1.416016,-1.708985 0.390625,-0.27832 0.791015,-0.439453 0.405274,-0.161133 0.683594,-0.161133 0.229492,0 0.341797,0.102539 0.117187,0.09766 0.117187,0.307617 0,0.07813 -0.01465,0.166016 -0.0098,0.08789 -0.03906,0.185547 -1.152343,0.09766 -1.865234,0.795898 -0.712891,0.698243 -0.961915,1.982422 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit6);
export default __webpack_public_path__ + "static/media/digit-6.fde03a333d718e37e92428128b5c8464.svg";
export { ForwardRef as ReactComponent };